<template>
  <div :class="['page', $gameTemplateStyle.completedGamePage]">
    <template v-if="this.game && this.user">
      <div ref="headerContainer" :class="[$globalStyle.headerContainer]">
        <template v-if="isHost">
          <HostHeaderBox
            :user="user"
            :allowedPlayers="game.allowedPlayers"
            :readingTime="game.readingTime"
            :discussionTime="game.discussionTime"
            :realTextLabel="game.realTextLabel"
            :saboteur="game.saboteur"
          />
          <HeaderActionButton
            :text="$t('home')"
            :clickFunction="hostGoHome"
            :iconLink="homeIcon"
            backBg="#000000"
            frontBg="#676767"
            textColor="#FFFFFF"
            :rightIcon="true"
            :icon-only="isMobile"
            :button-width="isMobile ? '60px' : isTablet ? '130px' : '140px'"
          />
        </template>
        <template v-else>
          <PlayerHeaderBox
            v-if="!isHost"
            :user="user"
            :allowedPlayers="game.allowedPlayers"
            :playersJoined="game.players?.length"
            :host="game.host"
            :joinCode="game.joinCode ? Number(game.joinCode) : null"
            :realTextLabel="game.realTextLabel"
            :isSaboteur="isSaboteur"
            :saboteur="game.saboteur"
            :playerGroup="gameGroupStore.myGroup"
          />
        </template>
      </div>
      <div ref="bodyContainer" :class="$style.bodyContainer">
        <template v-if="isHost">
          <div :class="$style.hostBodyContainer">
            <img :class="$style.thankImg" :src="thankYouIcon" alt="all-right!" />
            <div :class="$style.playerText">{{ $t('completed-game') }}</div>
            <div :class="$style.playerHelperText">
              {{ $t('download-transcript-desc') }}
            </div>
            <div :class="$style.hostActionsContainer">
              <ActionButton
                :text="$t('download-transcript')"
                :iconLink="downIcon"
                :clickFunction="downloadTranscript"
                backBg="#000000"
                frontBg="#676767"
                textColor="#FFFFFF"
                :rightIcon="true"
                :button-width="isMobile ? '260px' : isTablet ? '260px' : '340px'"
              />
              <ActionButton
                :text="$t('download-chat')"
                :iconLink="downIcon"
                :clickFunction="downloadChat"
                backBg="#000000"
                frontBg="#676767"
                textColor="#FFFFFF"
                :rightIcon="true"
                :button-width="isMobile ? '260px' : isTablet ? '260px' : '340px'"
              />
            </div>
          </div>
        </template>
        <template v-if="!isHost">
          <div :class="$style.playerBodyContainer">
            <img :class="$style.thankImg" :src="thankYouIcon" alt="all-right!" />
            <div :class="$style.playerText">{{ $t('thank-you') }}</div>
            <div :class="$style.playerHelperText">{{ $t('close-window') }}</div>
            <div :class="$style.playerActionsContainer">
              <ActionButton
                :text="$t('return-home')"
                :clickFunction="playerGoHome"
                :iconLink="homeIcon"
                backBg="#000000"
                frontBg="#676767"
                textColor="#FFFFFF"
                :rightIcon="true"
                :button-width="isMobile ? '260px' : isTablet ? '260px' : '340px'"
              />
            </div>
          </div>
        </template>
      </div>
    </template>

    <div v-if="showConfirmationModal" :class="$utilModalStyle.modalOverlay">
        <div :class="$utilModalStyle.modalContent">
          
          <h3 :class="$utilModalStyle.modalTitle">
            {{ $t("confirm-navigation-title") }}
          </h3>

          <div :class="[$utilModalStyle.modalBody]">
            <div :class="$style.primaryText">
              {{ $t("confirm-navigation-desc") }}
            </div>
          </div>

          <div :class="$utilModalStyle.modalActions">
            <button :class="$style.confirmBtn" @click="confirmGoHome">
              {{ $t("yes") }}
            </button>
            <button :class="$style.cancelBtn" @click="cancelGoHome">
              {{ $t("no") }}
            </button>
          </div>

        </div>
      </div>

    <!-- <div v-if="isLoading" :class="['loader-container']">
        <img :src="isHost ? hostLoaderGif : playerLoaderGif" alt="loader-gif" class="loader-gif" />
      </div> -->
  </div>
</template>

<script>
import { useGameStore } from "@/stores/gameStore";
import styles from "@/css/CompletedGameView.module.css";
import gameTemplateStyles from "@/css/GameViewTemplate.module.css";
import globalStyles from "@/css/global.module.css";
import PlayerHeaderBox from "@/components/playGame/PlayerHeaderBox.vue";
import HostHeaderBox from "@/components/playGame/HostHeaderBox.vue";
import ThankYouIcon from "@/assets/great.png";
import HomeIcon from "@/assets/icons/home-page-white.svg";
import DownIcon from "@/assets/icons/down-arrow-white.svg";
import gameService from "@/services/game.service";
import { useGameGroupStore } from "@/stores/game/gameGroupStore";
import HeaderActionButton from "@/components/buttons/HeaderActionButton.vue";
import ActionButton from "@/components/buttons/ActionButton.vue";
import useDeviceType from "@/utils/useDeviceType";
import utilModalStyles from "@/css/UtilModal.module.css";

const device = useDeviceType();

export default {
  components: { PlayerHeaderBox, HostHeaderBox, HeaderActionButton, ActionButton },
  name: "CompletedGameView",
  props: {},
  data() {
    return {
      thankYouIcon: ThankYouIcon,
      downIcon: DownIcon,
      homeIcon: HomeIcon,
      showConfirmationModal: false,
    };
  },
  computed: {
    $style() {
      return styles;
    },
    $gameTemplateStyle() {
      return gameTemplateStyles;
    },
    $utilModalStyle() {
      return utilModalStyles;
    },
    $globalStyle() {
      return globalStyles;
    },
    width() {
      return device.width.value;
    },
    height() {
      return device.height.value;
    },
    isMobile() {
      return device.isMobile.value;
    },
    isTablet() {
      return device.isTablet.value;
    },
    isDesktop() {
      return device.isDesktop.value;
    },
  },
  methods: {
    goHome() {
      this.$router.push({ name: "home" });
    },
    playerGoHome() {
      this.gameStore.$reset();
      this.clearRejoinState?.();
      this.gameGroupStore.resetAll();
      this.goHome();
    },
    hostGoHome() {
      this.showConfirmationModal = true;
    },
    confirmGoHome() {
      this.showConfirmationModal = false;
      this.gameStore.$reset();
      this.clearRejoinState?.();
      this.gameGroupStore.resetAll();
      this.goHome(); // Navigate to home if confirmed
    },
    cancelGoHome() {
      this.showConfirmationModal = false; // Close modal without navigating
    },
    downloadTranscript() {
      gameService.gameTranscriptDownload2({ gameId: this.game.gameId });
    },
    downloadChat() {
      gameService.messageTranscriptDownload2({ gameId: this.game.gameId });
    },
  },
  mounted() {
    if (!(this.game && this.game.gameId)) {
      this.goHome();
    }
  },
  beforeUnmount() {},
  setup() {
    const gameStore = useGameStore();
    const gameGroupStore = useGameGroupStore();

    // @see: primitive values are treated as snapshots in this way of declaration (Eg: isHost, isSaboteur)
    // use refs to make them reactive
    return {
      gameStore,
      game: gameStore.game,
      isHost: gameStore.isHost,
      user: gameStore.user,
      isSaboteur: gameStore.isSaboteur,
      gameGroupStore,
    };
  },
  watch: {},
};
</script>

<style scoped></style>
